<template>
  <div>
    <app-header ref="header">
      <div slot="right"></div>
    </app-header>
    <div class="app-body">
      <el-container class="app-container mt-4">
        <el-main>
          <div class="app-head">
            <div>
              <h4 class="app-title">教师开户申请</h4>
              <div class="app-desc">申请开通学分银行教师账户，开通后可完善个人终身账户信息。</div>
            </div>
            <div>
              <router-link to="/joint/query">查询开户申请进度</router-link>
            </div>
          </div>
          <div class="app-form">
            <div class="mt-3">
              <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="个人照片" prop="pic" fill="2">
                  <div style="line-height:1.5;">
                    <el-upload
                      class="avatar-uploader"
                      :headers="headers"
                      :action="uploadPic"
                      :on-success="handleUploadSuccess"
                      :before-upload="beforeUpload"
                      :limit="1"
                      :show-file-list="false"
                      accept=".jpg,.jpeg,.png"
                      list-type="picture">
                      <img v-if="form.pic" :src="imgPath(form.pic)" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      <div slot="tip" class="el-upload__tip text-muted"><span class="text-danger">* </span>只支持上传jpg/png图片，且不超过5MB</div>
                    </el-upload>
                  </div>
                </el-form-item>
                <el-form-item label="区域" prop="areaid">
                  <el-select v-model="form.areaid" filterable class="w-100">
                    <el-option v-for="item in areaList1" :label="item.name" :value="item.id" :key="item.id">
                      {{ item.name }}
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="教师分类" prop="cateid" ref="form.cateid">
                  <el-select v-model="form.cateid" v-loading="loading.teachercate" class="w-100">
                    <el-option v-for="item in teachercateList" :key="item.id" :value="item.id" :label="item.name">{{ item.name }}</el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="姓名" prop="name" ref="form.name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile" ref="form.mobile">
                  <el-input v-model="form.mobile"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="sex" fill="2">
                  <el-radio-group v-model="form.sex">
                    <el-radio :label="true">男</el-radio>
                    <el-radio :label="false">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="出生日期" prop="csny">
                  <el-date-picker v-model="form.csny" value-format="yyyy-MM-dd" :default-value="defaultDate" :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item label="民族" prop="mz">
                  <el-select v-model="form.mz" class="w-100">
                    <el-option v-for="item in mz" :key="item.id" :value="item.name" :label="item.name"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="政治面貌" prop="zzmm">
                  <el-select v-model="form.zzmm" class="w-100">
                    <el-option v-for="item in zzmm" :key="item.id" :value="item.name" :label="item.name"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="职称" prop="zc">
                  <el-input v-model="form.zc"></el-input>
                </el-form-item>
                <el-form-item label="学历" prop="xl">
                  <el-select v-model="form.xl" class="w-100">
                    <el-option v-for="item in xl" :key="item.id" :value="item.name" :label="item.name"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="授课学科" prop="zy">
                  <el-input v-model="form.zy"></el-input>
                </el-form-item>
                <el-form-item label="工作单位" prop="workunit">
                  <el-input v-model="form.workunit"></el-input>
                </el-form-item>
                <el-form-item label="常住地址" prop="address">
                  <el-input v-model="form.address"></el-input>
                </el-form-item>
                <el-form-item label="个人简介" prop="info" class="textarea" ref="form.info">
                  <el-input type="textarea" v-model="form.info" placeholder="输入个人简介（主要描述学习研修经历、教育教学和研究成果等，不超过500字）" 
                    :autosize="{minRows:4}" maxlength="500" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="相关资格证书" prop="zegepic" fill="2">
                  <div style="line-height:1.5;">
                    <div class="d-flex flex-wrap">
                      <template v-for="(item, index) in list1">
                        <div :key="`pic1-${index}`" class="mr-1 mb-1 zhengshu-item">
                          <el-image :src="imgPath(item)" :preview-src-list="[imgPath(item)]" fit="cover"></el-image>
                          <a href="javascript:;" class="del-item text-danger" @click="delPic1(index)">删除</a>
                        </div>
                      </template>
                      <el-upload
                        class="avatar-uploader zhengshu"
                        :headers="headers"
                        :action="uploadPic"
                        :on-success="handleUploadSuccess1"
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                        accept=".jpg,.jpeg,.png"
                        list-type="picture">
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </div>
                    <div class="mt-2 text-muted" style="font-size: 12px;"><span class="text-danger">* </span>只支持上传jpg/png图片，且不超过5MB</div>
                  </div>
                </el-form-item>
                <el-form-item label="所获荣誉" prop="rongyupic" fill="2">
                  <div style="line-height:1.5;">
                    <div class="d-flex flex-wrap">
                      <template v-for="(item, index) in list2">
                        <div :key="`pic1-${index}`" class="mr-1 mb-1 zhengshu-item">
                          <el-image :src="imgPath(item)" :preview-src-list="[imgPath(item)]" fit="cover"></el-image>
                          <a href="javascript:;" class="del-item text-danger" @click="delPic2(index)">删除</a>
                        </div>
                      </template>
                      <el-upload
                        class="avatar-uploader zhengshu"
                        :headers="headers"
                        :action="uploadPic"
                        :on-success="handleUploadSuccess2"
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                        accept=".jpg,.jpeg,.png"
                        list-type="picture">
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </div>
                    <div class="mt-2 text-muted" style="font-size: 12px;"><span class="text-danger">* </span>只支持上传jpg/png图片，且不超过5MB</div>
                  </div>
                </el-form-item>
                <!-- <el-form-item label="任教年级" prop="rjnj">
                  <el-input v-model="form.rjnj"></el-input>
                </el-form-item>
                <el-form-item label="任教学科" prop="rjxk">
                  <el-input v-model="form.rjxk"></el-input>
                </el-form-item> -->
                <el-form-item>
                  <el-button type="primary" @click="onSubmit('form')">立即申请</el-button>
                  <el-button @click="doCancel">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import AppHeader from '../app-header';
import AppFooter from '../app-footer';
import mz from 'jyutils/mz';
import zzmm from 'jyutils/zzmm';
import xl from 'jyutils/xl';
import { mobileOk } from 'jyutils/utils';
export default {
  mixins: [tools],
  components: { AppHeader, AppFooter },
  data () {
    return {
      form: {
        pic: null,
        areaid: '',
        cateid: '',
        name: '',
        mobile: '',
        sex: null,
        csny: '',
        mz: '',
        zzmm: '',
        zc: '',
        xl: '',
        zy: '',
        workunit: '',
        address: '',
        info: ''
      },
      list1: [],
      list2: [],
      rules: {
        areaid: { required: true, message: '请选择区域', trigger: 'blur' },
        cateid: { required: true, message: '请选择分类', trigger: 'blur' },
        name: { required: true, message: '请输入姓名', trigger: 'blur' },
        sex: { required: true, message: '请选择性别', trigger: 'blur' },
        zy: { required: true, message: '请输入授课学科', trigger: 'blur' },
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: (rule, val, callback) => {
              if (val) {
                if (!mobileOk(val)) {
                  callback(new Error('请输入正确的手机号！'));
                  return;
                }
              }
              callback();
            }
          }
        ],
        linkman: { required: true, message: '请输入联系人', trigger: 'blur' },
        email: { required: true, message: '请输入邮箱', trigger: 'blur' },
        info: { required: true, message: '请输入个人简介', trigger: 'blur' },
      }
    }
  },
  computed: {
    ...mapGetters({
      areaList: [types.BASE_LOAD.areaList],
      teachercateList: [types.BASE_LOAD.teachercateList],
      loading: [types.BASE_LOAD.baseLoading]
    }),
    defaultDate() {
      const date = new Date();
      return new Date(date.getFullYear() - 25, 0, 1);
    },
    pickerOptions() {
      return {
        disabledDate(date) {
          return date.getTime() > Date.now();
        }
      }
    },
    mz() {
      return mz;
    },
    zzmm() {
      return zzmm;
    },
    xl() {
      const excludes = ['01','02','03'];
      return xl.filter(d => !excludes.includes(d.id));
    }
  },
  created () {
  },
  mounted() {
  },
  activated () {
    if (!this.areaList || !this.areaList.length) {
      this.$store.dispatch(types.BASE_LOAD.areaList);
    }
    if (!this.teachercateList || !this.teachercateList.length) {
      this.$store.dispatch(types.BASE_LOAD.teachercateList);
    }
  },
  methods: {
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isJPG && isLt2M;
    },
    handleUploadSuccess(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.form.pic = res.obj.pic;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    handleUploadSuccess1(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.list1.push(res.obj.pic);
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    handleUploadSuccess2(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.list2.push(res.obj.pic);
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    delPic1(index) {
      this.msgbox('确定要删除该图片吗？', () => {
        this.list1.splice(index, 1);
      });
    },
    delPic2(index) {
      this.msgbox('确定要删除该图片吗？', () => {
        this.list2.splice(index, 1);
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid, obj) => {
        if (valid) {
          let postData = Object.assign({}, this.form);
          postData.list1 = this.list1;
          postData.list2 = this.list2;
          this.saveLoading = true;
          this.doPost({
            url: 'vue/teacher/apply',
            data: postData,
            okcb: (json) => {
              this.$router.push('/joint/view/'+ json.id);
            },
            cb: () => {
              this.saveLoading = false;
            }
          });
        } else {
          if (obj) {
            const keys = Object.keys(obj);
            const one = keys.length ? obj[keys[0]] : null;
            if (one) {
              try {
                this.$refs[`form.${keys[0]}`].$el.scrollIntoView({behavior: 'smooth', block: 'center'});
              } catch (error) {}
            }
          }
        }
      });
    },
    doCancel() {
      top.location.href = this.rootPath;
    },
    doReturn() {
      this.$router.push('/joint');
    }
  }
}
</script>
<style lang="less" scoped>
.app {
  &-head {
    .flex();
    justify-content:space-between;
  }
  &-title {
    font-size:2rem;
  }
  &-desc {
    color:#555;
  }
  &-form {
    margin-top:2rem;
    padding:2rem;
    background-color:#fff;
    .shadow-black(0 0 6px 0, .03);
    form {
      .el-form-item {
        max-width:600px;
        &.textarea {
          max-width:1000px;
        }
      }
    }
    .avatar-uploader {
      width: 100%;
      /deep/ .el-upload {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 5rem;
        height: 6rem;
      }
      &.zhengshu {
        width: auto;
        /deep/ .el-upload {
          height: 5rem;
        }
      }
    }
    .zhengshu-item {
      position: relative;
      width: 5rem;
      height: 5rem;
      .el-image {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &:hover {
        .del-item {
          display: block;
        }
      }
      .del-item {
        display: none;
        position:absolute; top:0; right:0; padding:1px 5px; line-height:1; background-color:rgba(255,255,255,.85);
      }
    }
  }
}
</style>